import { NumberInput } from 'components/NumberInput';
import { useSelector } from 'react-redux';
import { getMetricType } from 'store/settings/selectors';
import type { UnitInterface } from 'store/units/types';
import { CONVERSIONS, getMetricUnit } from 'util/conversions';
import { PSD_CALC_MODE } from '../types';
import { useEditFlowProperties } from '../useEditFlowProperties';
import type { FlowPropertiesProps } from '../withFlowProperties';
import { withFlowProperties } from '../withFlowProperties';

type Props = {
  activeUnit: UnitInterface;
  field: 'pxxOne' | 'pxxTwo' | 'pxxThree';
};

const PxxInput = ({
  id,
  activeUnit,
  flowProperties,
  field,
}: Props & FlowPropertiesProps) => {
  const metricType = useSelector(getMetricType);
  const { setValue } = useEditFlowProperties(id, activeUnit, flowProperties);

  return (
    <NumberInput
      value={flowProperties[field]}
      setValue={(val) => {
        if (
          flowProperties.psdCalcMode === PSD_CALC_MODE.PERCENT &&
          val !== undefined &&
          val > 100
        ) {
          setValue(field, 100);
        } else {
          setValue(field, val);
        }
      }}
      label={
        flowProperties.psdCalcMode === PSD_CALC_MODE.PERCENT
          ? `[%]`
          : `[${getMetricUnit(metricType, CONVERSIONS.CAPACITY)}]`
      }
      marginRight={16}
      optional
    />
  );
};

export default withFlowProperties(PxxInput);
